import { Trans } from "react-i18next";

import util from "utils/utils";

import type { NotificationContentProps } from "../../types";

const ProjectAssignedAssignee = ({
  events = [],
  ownerIdea,
  ownerChallenge,
}: NotificationContentProps) => {
  return (
    <Trans
      i18nKey="notifications.projectAssignedAssignee"
      values={{
        name: util.getEventNames(events ?? []),
        idea: ownerIdea?.name || "Deleted",
        challenge: ownerChallenge?.name || "Deleted",
      }}
    />
  );
};

export default ProjectAssignedAssignee;
